export const SEARCHES_MAX_NUM = 19;
export const SEARCH_NAME_MAX_LENGTH = 48;
